import { render, staticRenderFns } from "./AcademyEditDialog.vue?vue&type=template&id=11561bbc&scoped=true&"
import script from "./AcademyEditDialog.vue?vue&type=script&lang=js&"
export * from "./AcademyEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AcademyEditDialog.vue?vue&type=style&index=0&id=11561bbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11561bbc",
  null
  
)

export default component.exports